/**
 * Occupancy Style01 - Stitch v1: card + device name, MOTION DETECTED + 光暈光點
 */
import type { TraitControlProps } from './types'
import { getTraitConfig } from './traitStyleConfig'
import './OccupancyStyle01.css'

export function OccupancyStyle01({ device, state }: TraitControlProps) {
  const { icon } = getTraitConfig('Occupancy')
  const deviceName = device?.nickname ?? device?.name ?? device?.displayName ?? ''
  const occupied = (state?.occupancy ?? state?.occupied ?? state?.value ?? state?.motion) as boolean | string | undefined
  const isDetected = occupied === true || occupied === 'OCCUPIED' || occupied === 'occupied' || occupied === 'motion' || occupied === 'MOTION_DETECTED' || String(occupied).toLowerCase() === 'true'

  return (
    <div className="trait-occupancy-style01 trait-stitch-glass">
      <div className="trait-occupancy-style01__content">
        <span className="trait-occupancy-style01__name">{deviceName}</span>
        <span className={`trait-occupancy-style01__status ${isDetected ? 'detected' : ''}`}>
          {isDetected ? 'MOTION DETECTED' : 'No motion'}
        </span>
      </div>
      <div className="trait-occupancy-style01__indicator">
        {isDetected ? (
          <span className="trait-occupancy-style01__glow-dot" aria-hidden />
        ) : (
          <span className="material-symbols-outlined trait-occupancy-style01__icon">{icon}</span>
        )}
      </div>
    </div>
  )
}
